import React, { lazy, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { configureAxios } from '../utils/axiosInstance';
import ProtectedRoute from './ProtectedRoute';

const PaymentComplete = lazy(() => import('../pages/payment/PaymentComplete'));
const ServerError = lazy(() => import('../components/ServerError'));
const NetworkError = lazy(() => import('../components/NetworkError'));
const NotFound = lazy(() => import('../components/NotFound'));
const MainLayout = lazy(() => import('../components/MainLayout'));

const Login = lazy(() => import('../pages/home/Login'));
const MyPage = lazy(() => import('../pages/home/MyPage'));
const OrderProduct = lazy(() => import('../pages/order/OrderProduct'));
const OrderProductDetail = lazy(() => import('../pages/order/OrderProductDetail'));
const OrderCart = lazy(() => import('../pages/order/OrderCart'));
const OrderList = lazy(() => import('../pages/order/OrderList'));
const OrderListDetail = lazy(() => import('../pages/order/OrderListDetail'));

const SalesStatement = lazy(() => import('../pages/api/SalesStatement'));
const SalesSummary = lazy(() => import('../pages/api/SalesSummary'));

const NoticeForm = lazy(() => import('../pages/board_notice/NoticeForm'));
const Notice = lazy(() => import('../pages/board_notice/Notice'));
const PdsForm = lazy(() => import('../pages/board_pds/PdsForm'));
const Pds = lazy(() => import('../pages/board_pds/Pds'));
const SuggestDetail = lazy(() => import('../pages/board_suggest/SuggestDetail'));
const SuggestForm = lazy(() => import('../pages/board_suggest/SuggestForm'));
const Suggest = lazy(() => import('../pages/board_suggest/Suggest'));



function AppRoutes() {
  const { isAuthenticated } = useAuth();

  const navigate = useNavigate();
  useEffect(() => {
    configureAxios(navigate);
  }, [navigate]);


  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<ProtectedRoute element={<MyPage />} />} />
        <Route path="/mypage" element={<ProtectedRoute element={<MyPage />} />} />
        <Route path="/order/product/:id" element={<ProtectedRoute element={<OrderProduct />} />} />
        <Route path="/order/detail/:id" element={<ProtectedRoute element={<OrderProductDetail />} />} />
        <Route path="/order/cart" element={<ProtectedRoute element={<OrderCart />} />} />
        <Route path="/order/list" element={<ProtectedRoute element={<OrderList />} />} />
        <Route path="/order/list/:id" element={<ProtectedRoute element={<OrderList />} />} />
        <Route path="/order/list/detail/:id" element={<ProtectedRoute element={<OrderListDetail />} />} />

        <Route path="/api/statement" element={<ProtectedRoute element={<SalesStatement />} />} />
        <Route path="/api/summary" element={<ProtectedRoute element={<SalesSummary />} />} />
        
        <Route path="/notice/form" element={<ProtectedRoute element={<NoticeForm />} />} />
        <Route path="/notice/form/:id" element={<ProtectedRoute element={<NoticeForm />} />} />
        <Route path="/notice/list" element={<ProtectedRoute element={<Notice />} />} />
        <Route path="/notice/list/:id" element={<ProtectedRoute element={<Notice />} />} />
        <Route path="/pds/form/:id" element={<ProtectedRoute element={<PdsForm />} />} />
        <Route path="/pds/list" element={<ProtectedRoute element={<Pds />} />} />
        <Route path="/pds/list/:id" element={<ProtectedRoute element={<Pds />} />} />
        <Route path="/suggest/form" element={<ProtectedRoute element={<SuggestForm />} />} />
        <Route path="/suggest/list" element={<ProtectedRoute element={<Suggest />} />} />
        <Route path="/suggest/form/:id" element={<ProtectedRoute element={<SuggestForm />} />} />
        <Route path="/suggest/detail/:id" element={<ProtectedRoute element={<SuggestDetail />} />} />
        <Route path="/payment/complete" element={<ProtectedRoute element={<PaymentComplete />} />} />

        
      </Route>


      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route path="/server-error" element={<ServerError />} />
      <Route path="/network-error" element={<NetworkError />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;